import { render, staticRenderFns } from "./FloatingSidebar.vue?vue&type=template&id=24e1bbaf"
import script from "./FloatingSidebar.vue?vue&type=script&lang=js"
export * from "./FloatingSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports